export default __webpack_public_path__ + "static/media/ideas_1.0afbf613.PNG";